// src/stores/confirmDialogStore.js
import { defineStore } from 'pinia';

export const useConfirmDialogStore = defineStore('confirmDialog', {
  state: () => ({
    isOpen: false,
    title: "Attenzione",
    message: 'Sei sicuro?',
    resolvePromise: null as any,
  }),
  actions: {
    open(message = 'Sei sicuro?',title = 'Attenzione') {
      this.isOpen = true;
      this.message = message;
      this.title = title;
      return new Promise((resolve) => {
        this.resolvePromise = resolve;
      });
    },
    close() {
      this.isOpen = false;
      this.message = '';
      this.title = '';
      if (this.resolvePromise) {
        this.resolvePromise(false); 
        this.resolvePromise = null;
      }
    },
    confirm() {
      if (this.resolvePromise) {
        this.resolvePromise(true);
      }
      this.close();
    },
    cancel() {
      if (this.resolvePromise) {
        this.resolvePromise(false);
      }
      this.close();
    },
  },
});